import React from 'react'
import PropTypes from 'prop-types'

import { _ } from 'Services/I18n'

import { ServiceList } from 'Components/Blocks'
import LocationsDropdown from 'Components/Blocks/LocationsDropdown'
import { Box, Dash } from 'Components/UI'

import { useBaseTheme, useHydrated, useLocationFilter } from 'Hooks'
import {
  Container,
  Content,
  StyledTitle,
  GroupedServicesTitleText,
} from './styles'

function StickyServices({ merchant, services, showTitle, ...rest }) {
  const { bookingPanelTitle, bookingPanelCopy } = useBaseTheme()
  const hydrated = useHydrated()
  const { filteredServices, handleChangeLocation } = useLocationFilter(services)

  if (!hydrated) {
    return null
  }

  return (
    <Container {...rest}>
      <Content>
        {showTitle && (
          <>
            <StyledTitle>
              {bookingPanelTitle || _('common.bookNow')}
            </StyledTitle>
            <Dash mb={3} mt={2} />
          </>
        )}
        {bookingPanelCopy && (
          <GroupedServicesTitleText>
            {bookingPanelCopy}
          </GroupedServicesTitleText>
        )}
      </Content>
      <Box mt={3}>
        <LocationsDropdown
          fullWidth
          services={services}
          onChange={handleChangeLocation}
        />
      </Box>
      <Box mt={2}>
        <ServiceList merchant={merchant} services={filteredServices} />
      </Box>
    </Container>
  )
}

StickyServices.defaultProps = {
  merchant: null,
  services: null,
  showTitle: true,
}

StickyServices.propTypes = {
  merchant: PropTypes.object,
  services: PropTypes.array,
  showTitle: PropTypes.bool,
}

export default StickyServices
